import FYLZRecordList from './src/FYLZRecordList.vue';
import PM10RecordList from './src/PM10RecordList.vue';
import PM25RecordList from './src/PM25RecordList.vue';
import WDRecordList from './src/WDRecordList.vue';
import SDRecordList from './src/SDRecordList.vue';


let views = {
    FYLZRecordList,
    PM10RecordList,
    PM25RecordList,
    WDRecordList,
    SDRecordList
};

export default views;